import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue'),
    meta: { requiresAuth: true, roles: ['client', 'vip_client'] }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/Orders.vue'),
    meta: { requiresAuth: true, roles: ['client', 'vip_client'] }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/Cart.vue'),
    meta: { requiresAuth: true, roles: ['client', 'vip_client'] }
  },
  {
    path: '/manage',
    name: 'Manage',
    component: () => import('../views/Manage.vue'),
    meta: { requiresAuth: true, roles: ['manager', 'admin'] }
  },
  {
    path: '/manager-orders',
    name: 'ManagerOrders',
    component: () => import('../views/ManagerOrders.vue'),
    meta: { requiresAuth: true, roles: ['manager', 'admin'] }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/instructions',
    name: 'Instructions',
    component: () => import('../views/Instructions.vue'),
    meta: { requiresAuth: true, roles: ['client', 'vip_client'] }
  },
  {
    path: '/mc-bauchemie',
    name: 'MCBauchemie',
    component: () => import('../views/MCBauchemie.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Защита маршрутов
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  if (authStore.token && !authStore.user) {
    await authStore.checkAuth()
  }
  
  // Если пользователь авторизован и пытается зайти на страницу логина
  if (to.path === '/login' && authStore.isAuthenticated && authStore.user) {
    next(authStore.getDefaultRoute())
    return
  }
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.roles && !to.meta.roles.includes(authStore.user?.role)) {
    // Редирект в зависимости от роли пользователя
    next(authStore.getDefaultRoute())
  } else {
    next()
  }
})

export default router
